export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14225.61804c28.jpg";